import React from 'react';
import { Container, Grid, Typography } from '@mui/material';

import { sxStyle } from './styles';

const NoResultsFlight = ({ tripLegs }) => {
  const cityMultipleDestination = tripLegs => {
    let city = '';
    tripLegs.forEach((element, index) => {
      city += `${element?.origin?.label} / ${element?.destination?.label}`;
      if (index != tripLegs?.length - 1) {
        city += ' - ';
      }
    });

    return city;
  };

  const cityList =
    tripLegs?.length > 0 ? cityMultipleDestination(tripLegs) : '';

  return (
    <Container sx={sxStyle.rootNoResultsText}>
      <Grid>
        <Typography variant="h5" sx={sxStyle.noResultsText} align="center">
          Lo sentimos, no se encontraron resultados disponibles para
        </Typography>
        <Typography sx={sxStyle.noCity}>{cityList}</Typography>
      </Grid>
    </Container>
  );
};

export default NoResultsFlight;
